import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/service' },
    { name: 'Services', path: '/service/services' },
    { name: 'About', path: '/service/about' },
    { name: 'Contact', path: '/service/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-50 bg-slate-950/70 backdrop-blur-xl border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/service"
            data-testid="nav-logo-link"
            className="flex items-center gap-3 group"
          >
            <div className="relative">
              <div className="absolute -inset-1 rounded-full bg-cyan-500/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <img
                src="https://customer-assets.emergentagent.com/job_fcf8fe40-6235-4ae1-a5a5-ebd4002e0a55/artifacts/8jty1yq0_Gemini_Generated_Image_l9r4ujl9r4ujl9r4.png"
                alt="Propitstop Logo"
                className="relative h-11 w-11 object-cover rounded-xl ring-1 ring-white/10"
              />
            </div>
            <div className="leading-tight">
              <div className="font-extrabold text-lg text-white tracking-tight">Propitstop</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 font-medium">Car Services</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`relative text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path) ? 'text-cyan-400' : 'text-slate-300 hover:text-white'
                }`}
              >
                {link.name}
                <span
                  className={`absolute -bottom-1.5 left-0 h-px bg-gradient-to-r from-cyan-400 to-blue-400 transition-transform duration-300 origin-left ${
                    isActive(link.path) ? 'w-full scale-x-100' : 'w-full scale-x-0'
                  }`}
                />
              </Link>
            ))}
            <Link to="/service/services" data-testid="nav-book-service-btn">
              <Button className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold rounded-xl px-5 shadow-[0_0_15px_rgba(6,182,212,0.25)] hover:shadow-[0_0_22px_rgba(6,182,212,0.45)] transition-[box-shadow,background-color] duration-300">
                Book Service
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            className="md:hidden p-2 rounded-lg text-slate-200 hover:text-cyan-400 hover:bg-white/5 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-white/5">
            <div className="flex flex-col gap-1">
              {navLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                  className={`font-medium px-4 py-3 rounded-lg transition-colors ${
                    isActive(link.path)
                      ? 'text-cyan-400 bg-cyan-500/10'
                      : 'text-slate-300 hover:text-white hover:bg-white/5'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/service/services" onClick={() => setIsOpen(false)} className="mt-2">
                <Button
                  data-testid="mobile-book-service-btn"
                  className="w-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold rounded-xl"
                >
                  Book Service
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
